<template>
  <div class="cube-loader">
    <div class="sh1"></div>
    <div class="sh2"></div>
    <div class="text-xs mt-6">
      {{ $t('welcome.scan_code_processing')}} ....
    </div>
  </div>
</template>

<script>
export default {
  name: 'CubeLoader',
};
</script>

<style lang="scss" scoped>
@keyframes shk1 {
  0% {
    transform: rotate(-360deg);
  }

  100% {
  }
}

@keyframes shk2 {
  0% {
    transform: rotate(360deg);
  }
  100% {
  }
}

.cube-loader {
  opacity: 0.5;
}

.sh1 {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 30px 30px 0 0;
  border-color: #2245FF transparent transparent transparent;
  margin: 0 auto;
  animation: shk1 1s ease-in-out infinite normal;
}

.sh2 {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 0 30px 30px;
  border-color: transparent transparent #540DEB transparent;
  margin: -30px auto 0;
  animation: shk2 1s ease-in-out infinite alternate;
}
</style>
